import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { B2BIdentityProvider } from '@stytch/react/b2b';

import SignInPanel from '@/app/sign-in/SignInPanel';
import { FullPage } from '@/components/page';
import { Text } from '@/components/typography';
import { useMe } from '@/providers/User';
import {
  COLOR_GRAY_600,
  COLOR_GRAY_900,
  COLOR_GREEN_400,
  COLOR_PRIMARY,
  COLOR_RED_400,
  COLOR_RED_500,
  COLOR_TRANSPARENT,
  COLOR_WHITE,
  COLOR_YELLOW_400,
} from '@/styles/palette';

const OAuthConsent = () => {
  const user = useMe();

  return (
    <FullPage title={t`OAuth Consent`}>
      <SignInPanel
        className="stytch-oauth-wrapper"
        footer={
          <Text className="text-center" variant="caption1" color="grey">
            <Trans>
              You are signed in as {user?.email} in {user?.currentOrg.name}
            </Trans>
          </Text>
        }
      >
        <div className="[&>div]:p-0!">
          <B2BIdentityProvider
            presentation={{
              theme: {
                // accept button
                primary: COLOR_PRIMARY,
                'primary-foreground': COLOR_GRAY_900,
                'primary-button-hover': COLOR_GREEN_400,

                // deny button
                accent: COLOR_GRAY_900,
                'accent-foreground': COLOR_WHITE,
                background: COLOR_WHITE,

                destructive: COLOR_RED_400,
                'destructive-foreground': COLOR_WHITE,
                'destructive-button-hover': COLOR_RED_500,

                secondary: COLOR_GRAY_600,
                success: COLOR_GREEN_400,
                warning: COLOR_YELLOW_400,

                'font-family': 'Inter, sans-serif',
                'container-border': COLOR_TRANSPARENT,
                'button-radius': '2px',
              },
            }}
          />
        </div>
      </SignInPanel>
    </FullPage>
  );
};

export default OAuthConsent;
